<template>
  <div class="author-share-links__wrapper">
    <a-icon-list class="author-share-links" :icons="icons" open-in-new-tab />
  </div>
</template>

<script>
import AIconList from 'shared/AIconList'
import { ICON } from 'shared/AIcon'
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'AuthorIcons',
  components: { AIconList },
  props: {
    facebookUrl: propValidator([PROP_TYPES.STRING], false),
    twitterUrl: propValidator([PROP_TYPES.STRING], false),
    linkedInUrl: propValidator([PROP_TYPES.STRING], false),
    telegramUrl: propValidator([PROP_TYPES.STRING], false)
  },
  computed: {
    icons() {
      return [
        { url: this.twitterUrl, icon: ICON.TWITTER_ROUND_BLACK },
        { url: this.facebookUrl, icon: ICON.FACEBOOK_ROUND_BLACK },
        { url: this.linkedInUrl, icon: ICON.LINKEDIN_ROUND_BLACK },
        { url: this.telegramUrl, icon: ICON.TELEGRAM_ROUND_BLACK }
      ].filter(({ url }) => url)
    }
  }
}
</script>

<style lang="scss" scoped>
.author-share-links__wrapper {
  display: flex;
  margin: 20px 0;
}
</style>
